import React from "react";
import SingleDonation from "../../items/SingleDonation";

const DonationsList = ({ data = [] }) => {
  return (
    <>
      <div className="relative space-y-5 px-0 py-4  xl:px-4 xl:py-4">
        {data.length > 0 &&
          data.map((item) => <SingleDonation key={item._id} data={item} />)}
      </div>
    </>
  );
};

export default DonationsList;
